module.exports = {
    tag: 'ulrich',
    quality: 1.0,
    physDamageMod: 0.05
}